import { Component, OnInit } from "@angular/core";
import { NavController } from "@ionic/angular";
import { PersonalDataService } from "../../service/personal-data.service";
import { BackNativeService } from "../../../shared/service/comunicator-native/back-native/back-native";
import { FormBuilder, FormControl } from "@angular/forms";
import { FormValidations } from "../../../shared/form-validation/form-validation";
import { Title } from "@angular/platform-browser";
import { DefaultPageComponent } from "../../../shared/page/default-page.component";
import { JourneyService } from "../../../shared/service/journey/journey.service";
import { ReturnNativeService } from "../../../shared/service/comunicator-native/return-native/return-native";
import { AnalycticsNativeService } from "../../../shared/service/comunicator-native/analytics-native/analyctics-native";
import {
  Keyboard,
  KeyboardResizeMode,
} from "@awesome-cordova-plugins/keyboard/ngx";
import { AnalyticsPageModel } from "../../../shared/model/analyticsPage";
import { AnalyticsPageService } from "../../../shared/service/analytics/analytics-page.service";
import { TrackTypes } from "../../../shared/service/journey/tracks/model/track-types";
import { AnalyticsGA4PageService } from "../../../shared/service/analytics-ga4-pages/analytics-ga4-page.service";
import { AnalyticsGA4PagesModel } from "../../../shared/service/analytics-ga4-pages/analytics-ga4-pages-models";

@Component({
  selector: "app-document-name",
  templateUrl: "./document-name.component.html",
  styleUrls: ["./document-name.component.scss"],
})
export class DocumentNameComponent
  extends DefaultPageComponent
  implements OnInit
{
  public name = "";
  public idComponentName = "documentName";
  placeholder = "Nome completo";
  error = false;
  buttonEnable = false;
  maxLength = "61";
  textError = "";
  minLengthErrorText = "Esse nome está incompleto";
  invalidErrorText = "Nome inválido";
  maxLengthErrorText =
    "Limite de caracteres alcançado, você pode abreviar os nomes do meio";
  nameNative = "";
  idLabel = "nameLabel";
  label = "nome completo";
  startStage = "";
  endStage = "";
  analyticsPage: AnalyticsPageModel;
  analyticsPageGA4: AnalyticsGA4PagesModel;
  idLabelName = "labelName";
  idButtonName = "buttonName";
  nameForm = this.formBuilder.group({
    docName: this.formBuilder.control("", [
      FormValidations.checkShortNameComplete,
      FormValidations.validationsNameV2,
    ]),
  });

  headerId = "document-name";
  titlePage = "Dados pessoais";

  constructor(
    public router: NavController,
    private personalDataService: PersonalDataService,
    public backNativeService: BackNativeService,
    public journeyService: JourneyService,
    private formBuilder: FormBuilder,
    private title: Title,
    public returnNativeService: ReturnNativeService,
    public analycticsNativeService: AnalycticsNativeService,
    private keyBoard: Keyboard,
    private analyticsPageService: AnalyticsPageService,
    private analyticsGA4PageService: AnalyticsGA4PageService
  ) {
    super(backNativeService, journeyService, router, returnNativeService);
    this.getAnalyticsPage();
    this.getAnalyticsPageGA4();
    this.getTrack();
    this.keyBoard.setResizeMode(KeyboardResizeMode.Body);
  }

  /* istanbul ignore next */
  get docName() {
    return this.nameForm.get("docName");
  }

  /* istanbul ignore next */
  ngOnInit() {
    this.setTitle();
    this.headerFocus();
    this.editFieldInvest(
      "nome_completo_documento",
      "documentName",
      "personalData"
    );
  }

  getAnalyticsPage() {
    this.analyticsPage = this.analyticsPageService.setAnalyticsPage();
  }

  getAnalyticsPageGA4() {
    this.analyticsPageGA4 = this.analyticsGA4PageService.setAnalyticsPageGA4();
  }

  ionViewWillEnter() {
    this.headerFocus();
    this.setEditPageRegistratio();
    this.getNameNative();
    this.analyticsData();
    this.sendTrackGA4LoadPage();
  }

  ionViewDidLeave() {
    this.ariaHidden = true;
  }

  getTrack() {
    const track = this.journeyService.selectedTrack;
    const path = "personal-data";

    if (
      this.journeyService.journey === TrackTypes.CONTA_ION ||
      this.journeyService.journey === TrackTypes.CONTA_ION_PERSONAL
    ) {
      this.startStage = "1";
      this.endStage = "11";
    } else {
      this.startStage = (
        track.getIndexPage(this.headerId, path) - 1
      ).toString();
      this.endStage = (track.getTotalPage(path) - 1).toString();
    }
  }

  analyticsData() {
    const it_pagename = this.analyticsPage.documentName;
    this.analycticsNativeService.analyticsTrackStateCommunicator(it_pagename);
  }

  sendTrackGA4LoadPage() {
    const paramDefautl = {
      event_name: this.analyticsPageGA4.eventNameScreenView,
      custom_path: this.analyticsPageGA4.customPathNomeCompleto,
      implementation_team: this.analyticsPageGA4.implementationTeam,
    };

    this.analyticsGA4PageService.sendTrackGA4(paramDefautl);
  }

  setTitle() {
    this.title.setTitle(this.titlePage);
  }

  clickNext() {
    /* tslint:disable:no-string-literal */
    this.personalDataService.setFullName(this.name.trim());
    this.nextPage();
  }

  analyticsEventClique() {
    const it_eventcategory = "Clique";
    const it_complementary = {
      it_eventaction: this.analyticsPage.action,
      it_eventlabel: this.analyticsPage.back,
      it_pagename: this.analyticsPage.documentName,
    };
    this.analycticsNativeService.analyticsTrackActionCommunicator(
      it_eventcategory,
      it_complementary
    );
  }

  getPageId(): string {
    return this.headerId;
  }

  /* istanbul ignore next */
  getNameNative() {
    if (!this.journeyService.selectedTrack.isUncoupled()) {
      this.nameNative =
        this.journeyService.registratioJourney?.data?.profileData?.name ===
          undefined ||
        this.journeyService.registratioJourney.data?.profileData?.name === ""
          ? this.journeyService.registratioJourney.data.personalData.name
          : this.journeyService.registratioJourney.data?.profileData?.name;
    } else {
      this.nameNative =
        this.journeyService.registratioJourney?.data?.personalData?.name;
    }
  }

  errorMsg() {
    const control = this.nameForm.get("docName") as FormControl;
    this.error = control.errors !== null;

    this.error ? (this.buttonEnable = false) : (this.buttonEnable = true);

    if (
      control.errors !== null &&
      control.errors.hasOwnProperty("checkShortNameMin")
    ) {
      this.textError = this.minLengthErrorText;
    }

    if (
      control.errors !== null &&
      control.errors.hasOwnProperty("checkShortNameMax")
    ) {
      this.textError = this.maxLengthErrorText;
    }

    if (
      control.errors !== null &&
      control.errors.hasOwnProperty("nameLastname")
    ) {
      this.textError = this.minLengthErrorText;
    }
  }

  setValueInput($event: string, input: string) {
    const maxLength = parseInt(this.maxLength, 10);

    this.name = $event.substring(0, maxLength);
    this.nameForm.controls[input].setValue($event.substring(0, maxLength));
    this.nameForm.controls[input].updateValueAndValidity();

    this.errorMsg();
  }

  submitForm($event: any) {
    $event.preventDefault();
    return false;
  }

  setEditPageRegistratio() {
    if (
      this.journeyService.registratioJourney.data?.personalData?.documentName?.split(
        " "
      ).length > 1
    ) {
      this.name =
        this.journeyService.registratioJourney.data?.personalData?.documentName;
      this.nameForm.controls.docName.setValue(
        this.journeyService.registratioJourney.data?.personalData?.documentName
      );
      this.errorMsg();
    }
  }

  backPage() {
    this.analyticsEventClique();
    this.back();
  }
}
